import { Component, AfterViewInit, Input, Output, EventEmitter } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'wl-event-settings-registration-fields-field-row',
  templateUrl: 'event-settings-registration-fields-field-row.component.html',
    standalone: false
})
export class EventSettingsRegistrationFieldsFieldRowComponent implements AfterViewInit {
  @Input() displayName: string;
  @Input() public offsetClass: string = 'col-sm-offset-1';
  @Input() public registrationRequiredDisabled: boolean = false;
  @Input() public registrationVisibleDisabled: boolean = false;
  @Input() public attendeeRequiredDisabled: boolean = false;
  @Input() public attendeeVisibleDisabled: boolean = false;
  @Input()
  set visibilityFieldValue(visibilityFieldValue: number) {
    // assign the underlying boolean properties that are used in the binding depending on the bitwise value passed to the control
    this.regVisible = (visibilityFieldValue & 1) > 0;
    this.regRequired = this.regRequired && this.regVisible;
    this.attVisible = (visibilityFieldValue & 2) > 0;
    this.attRequired = this.attRequired && this.attVisible;
  }
  get visibilityFieldValue() {
    return this.boolsToInt(this.regVisible, this.attVisible);
  }

  @Input()
  set requiredFieldValue(requiredFieldValue: number) {
    // assign the underlying boolean properties that are used in the binding depending on the bitwise value passed to the control
    this.regRequired = (requiredFieldValue & 1) > 0;
    this.regVisible = this.regVisible || this.regRequired;
    this.attRequired = (requiredFieldValue & 2) > 0;
    this.attVisible = this.attVisible || this.attRequired;
  }
  get requiredFieldValue() {
    let value: number = 0;
    return this.boolsToInt(this.regRequired, this.attRequired);
  }

  @Input() regVisibleFieldVisible: boolean = true;
  @Input() regRequiredVisible: boolean = true;
  @Input() attVisibleFieldVisible: boolean = true;
  @Input() attRequiredVisible: boolean = true;

  public regVisible: boolean = false;
  public regRequired: boolean = false;
  public attVisible: boolean = false;
  public attRequired: boolean = false;
  public _timeoutId: number = 0;

  public constructor() {
    this.regVisibleFieldVisible = true;
    this.regRequiredVisible = true;
    this.attVisibleFieldVisible = true;
    this.attRequiredVisible = true;
  }

  @Output() visibilityFieldValueChange: EventEmitter<number> = new EventEmitter<number>();
  @Output() requiredFieldValueChange: EventEmitter<number> = new EventEmitter<number>();
  ngAfterViewInit() {
    //this.setCheckBoxValues();
  }

  /// regReqCheckboxChanged
  /// Fired when the registration required checkbox is changed
  /// need to get the value of each checkbox individually in order for binding to respect changes
  public regReqCheckboxChanged = (e: any): void => {
    let regVisNew: boolean = this.regVisible || e.target.checked;
    let regReqNew: boolean = e.target.checked;
    this.regVisReqValueChanged(regReqNew, regVisNew, this.attRequired, this.attVisible);
  };

  /// regVisCheckboxChanged
  /// Fired when the registration visibility checkbox is changed
  /// need to get the value of each checkbox individually in order for binding to respect changes
  public regVisCheckboxChanged = (e: any): void => {
    let regReqNew = this.regRequired && e.target.checked;
    let regVisNew = e.target.checked;
    this.regVisReqValueChanged(regReqNew, regVisNew, this.attRequired, this.attVisible);
  };

  /// attReqCheckboxChanged
  /// Fired when the attendee required checkbox is changed
  /// need to get the value of each checkbox individually in order for binding to respect changes
  public attReqCheckboxChanged = (e: any): void => {
    let attVisNew: boolean = this.attVisible || e.target.checked;
    let attReqNew: boolean = e.target.checked;
    this.regVisReqValueChanged(this.regRequired, this.regVisible, attReqNew, attVisNew);
  };

  /// attVisCheckboxChanged
  /// Fired when the attendee visibility checkbox is changed
  /// need to get the value of each checkbox individually in order for binding to respect changes
  public attVisCheckboxChanged = (e: any): void => {
    let attReqNew: boolean = this.attRequired && e.target.checked;
    let attVisNew: boolean = e.target.checked;
    this.regVisReqValueChanged(this.regRequired, this.regVisible, attReqNew, attVisNew);
  };

  public regVisReqValueChanged = (regReqNew: boolean, regVisNew: boolean, attReqNew: boolean, attVisNew: boolean): void => {
    let reqValue: number = this.boolsToInt(regReqNew, attReqNew);
    let visValue: number = this.boolsToInt(regVisNew, attVisNew);
    this.visibilityFieldValueChange.emit(visValue);
    this.requiredFieldValueChange.emit(reqValue);
  };

  /// Takes a pair of booleans and determines the bitwise result
  public boolsToInt = (reg: boolean, att: boolean) => {
    let value: number = 0;
    value |= reg ? 1 : 0;
    value |= att ? 2 : 0;
    return value;
  };
}
